<template>
	<time :time="value">
		<template v-if="date">{{ aMoment | dateFormat(format, parseZone) }}</template>
		<template v-else>{{ aMoment | dateTimeFormat(format, parseZone) }}</template>
	</time>
</template>

<script>
export default
{
	props:
	{
		value:
		{
			required: true,
		},

		date:
		{
			type:    Boolean,
			default: true,
		},

		format:
		{
			type: String,
		},

		parseZone:
		{
			type: Boolean,
			default: false
		},
	},

	computed:
	{
		aMoment()
		{
			return this.value && this.moment(this.value)
		},

		isValid()
		{
			return this.aMoment && this.aMoment.isValid()
		},
	},
}
</script>